import { formatDate, Label } from '@easylife365/react';
import type { DateColumnProps } from './types';

const DateColumn: React.FC<DateColumnProps> = ({ date }) => {
  if (!date) return null;

  const titleDate = formatDate(date, {
    useRelativeTime: false,
    formatOptions: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: 'numeric',
      minute: 'numeric',
    },
  });
  const targetDate = formatDate(date);

  return <Label label={targetDate} title={titleDate} />;
};

export default DateColumn;
